import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vShow as _vShow, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/package.svg'


const _withScopeId = n => (_pushScopeId("data-v-40a3d9b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "package-body",
  draggable: "false"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "package-icon"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 0,
  class: "package-title"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass(["icon-button package-button", { 'red-svg': _ctx.robotPackage }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showButtons = !_ctx.showButtons)),
      onDblclick: _cache[1] || (_cache[1] = ($event: any) => (
        _ctx.robotPackage ||
          _ctx.$router.push(
            `/nodesCanvas/${_ctx.workspaceId}/${_ctx.packageName}/${_ctx.packageId}`
          )
      ))
    }, _hoisted_3, 34),
    (!_ctx.editingName)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.packageName), 1))
      : _createCommentVNode("", true),
    (_ctx.editingName)
      ? _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 1,
          class: "edit-name-input",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editedName) = $event)),
          onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.submitInput()), ["enter"])),
          onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.submitInput()))
        }, null, 544)), [
          [_vModelText, _ctx.editedName]
        ])
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "topic" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("button", {
          class: "circle-button topic-bg topic-btn",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openWindow(_ctx.packageId, 'topic')))
        }, " Topics ", 512), [
          [_vShow, _ctx.showButtons && _ctx.topics.length > 0]
        ])
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "service" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("button", {
          class: "circle-button service-bg service-btn",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openWindow(_ctx.packageId, 'service')))
        }, " Services ", 512), [
          [_vShow, _ctx.showButtons && _ctx.services.length > 0]
        ])
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "node" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("button", {
          class: "circle-button node-bg node-btn",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openWindow(_ctx.packageId, 'node')))
        }, " Nodes ", 512), [
          [_vShow, _ctx.showButtons && _ctx.nodes.length > 0]
        ])
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "bounce" }, {
      default: _withCtx(() => [
        (_ctx.editing && !_ctx.robotPackage)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "circle-button edit-btn",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.editClicked()))
            }, " ✎ "))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "bounce" }, {
      default: _withCtx(() => [
        (_ctx.editing && !_ctx.robotPackage)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "circle-button delete-btn",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onDelete()))
            }, " × "))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}